"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexDiv = void 0;
exports.default = IconText;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
exports.FlexDiv = FlexDiv;
function IconText(_ref) {
  var name = _ref.name,
    group = _ref.group,
    state = _ref.state,
    text = _ref.text,
    size = _ref.size;
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement(FlexDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: breakPoint.sm ? 3 : 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: name,
    group: group,
    state: state,
    size: size
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, null, text));
}
IconText.propTypes = {
  name: _propTypes.default.string.isRequired,
  group: _propTypes.default.string,
  state: _propTypes.default.string,
  text: _propTypes.default.string,
  size: _propTypes.default.number
};